import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import TeamStat from "@/components/TeamStat";

const useStyles = makeStyles(theme => ({
  container: {
    margin: '0 0 20px',
  },
}));

function createStatObj(teams, stats){
  const home = teams.home;
  const visitor = teams.visitor;

  const homeStat = stats.find(stat => stat.id === home);
  const visitorStat = stats.find(stat => stat.id === visitor);

  return {
    home: {
      team: teams[home],
      stat: homeStat.stat,
    },
    visitor: {
      team: teams[visitor],
      stat: visitorStat.stat,
    }
  }
}

function GameStat({ title, teams, stats }) {
  const classes = useStyles();
  const stat = createStatObj(teams, stats);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h6" component="p">{title}</Typography>
      </Grid>
      <Grid item xs={12}>
        <TeamStat stat={stat} side="visitor" />
      </Grid>
      <Grid item xs={12}>
        <TeamStat stat={stat} side="home" />
      </Grid>
    </Grid>
  )
}

export default GameStat;
